<template>
    <div class="mobile-common-menu" :class="{'mobile-common-menu--open': mobileFavoritesMenu}">
        <template v-if="mobileFavoritesMenu">
            <div class="mobile-common-menu__container js-mobile-menu-container">
                <div class="mobile-common-menu__container-inner">
                    <div class="mobile-common-menu__content">
                        <div v-if="favoriteItemsLength > 0" class="mobile-common-menu__favorites">
                            <h4>{{ $tc('n_selected_photos', favoriteItemsLength, {amount: favoriteItemsLength}) }}</h4>
                            <ul>
                                <li v-for="(item, i) in favoriteItems" :key="i">
                                    <img :src="item.photoPath" alt="">
                                </li>
                            </ul>
                        </div>
                        <ul class="mobile-common-menu__links">
                            <li class="mobile-menu__link mobile-menu__link--success mobile-menu__link--has-shadow mobile-menu__link--has-icon-left">
                                <a href="#" @click.prevent="orderSelected()">
                                    <span class="material-icon icon-add"/>
                                    {{ $tc('order_n_selected_photos', favoriteItemsLength, {amount: favoriteItemsLength}) }}
                                </a>
                            </li>
                            <li class="mobile-menu__link mobile-menu__link--has-icon-left">
                                <a href="#" @click.prevent="goTo(i18nLink(`selected/${album.status === '2' ? `${album.hash}-${album.hash_password}` : album.id}`))">
                                    <span class="material-icon icon-library_add"/>
                                    {{ $t('show_selected') }}
                                </a>
                            </li>
                            <li v-if="getDownloadPhotos(favoriteItems).length > 0" class="mobile-menu__link mobile-menu__link--has-icon-left">
                                <a href="#" @click.prevent="downloadPhotos(getDownloadPhotos(favoriteItems))">
                                    <span class="material-icon icon-cloud_download"/>
                                    {{ $tc('download_n_photos', favoriteItemsLength, {amount: getDownloadPhotos(favoriteItems).length}) }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <a href="#" @click.prevent="$store.dispatch('SET_MOBILE_FAVORITES_MENU', false)" class="mobile-common-menu__btn -red">
                <span class="material-icon icon-clear"/>
            </a>
        </template>
        <a v-else href="#" class="action-link" @click.prevent="$store.dispatch('SET_MOBILE_FAVORITES_MENU', true)">
            <span class="material-icon icon-library_add"/>
            <span class="action-link__txt">{{ $t('selected') }}</span>
            <span v-if="!!favoriteItemsLength && products && products.length > 0" class="badge badge-success">{{ favoriteItemsLength }}</span>
        </a>
    </div>
</template>

<script>
  import MobileFavoritesMenu from 'src/mixins/mobileFavoritesMenuComponent';

  export default {
    mixins: [MobileFavoritesMenu],
  };
</script>
